import React from 'react';
import MemberMonitor from '../components/MemberMonitor';

// Open to every signed-in member -- see MemberMonitor for what admins see extra.
export default function SessionManagement() {
  return <MemberMonitor mode="sessions" />;
}
